// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prompts-mine-container {
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
}

.prompts-desc {
    font-size: 14px;
    color: #666;
}

.prompts-title {
    font-size: 18px;
    font-weight: bold;
    color: #888;
    margin-bottom: 10px;
    margin-top: 20px;
}

.add-prompt-button {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    margin-bottom: 10px;
}

.prompts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 14px;
    margin-top: 10px;
}

@media (max-width: 768px) {
    .prompts-container {
        padding: 10px 5px;
    }

    .prompts-grid {
        grid-template-columns: 1fr;
    }

    .prompts-title {
        font-size: 16px;
    }

    .prompts-desc {
        font-size: 12px;
    }
}


.language-select-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.language-label {
    margin-right: 10px;
    font-size: 14px;
}

.language-select {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    max-width: 200px;
}

.load-more-button {
    color: dodgerblue;
    font-size: 18px;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.load-more-button:hover {
    background-color: rgba(30, 144, 255, 0.1);
}

@media (max-width: 768px) {
    .language-select-container {
        flex-direction: column;
        align-items: flex-start;
    }

    .language-label {
        margin-bottom: 5px;
    }

    .language-select {
        width: 100%;
        max-width: none;
    }

    .load-more-button {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/settings/prompts.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".prompts-mine-container {\n    padding: 20px 10px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 20px;\n}\n\n.prompts-desc {\n    font-size: 14px;\n    color: #666;\n}\n\n.prompts-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: #888;\n    margin-bottom: 10px;\n    margin-top: 20px;\n}\n\n.add-prompt-button {\n    width: fit-content;\n    margin-bottom: 10px;\n}\n\n.prompts-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    grid-gap: 14px;\n    margin-top: 10px;\n}\n\n@media (max-width: 768px) {\n    .prompts-container {\n        padding: 10px 5px;\n    }\n\n    .prompts-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .prompts-title {\n        font-size: 16px;\n    }\n\n    .prompts-desc {\n        font-size: 12px;\n    }\n}\n\n\n.language-select-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.language-label {\n    margin-right: 10px;\n    font-size: 14px;\n}\n\n.language-select {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n    max-width: 200px;\n}\n\n.load-more-button {\n    color: dodgerblue;\n    font-size: 18px;\n    text-align: center;\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.load-more-button:hover {\n    background-color: rgba(30, 144, 255, 0.1);\n}\n\n@media (max-width: 768px) {\n    .language-select-container {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .language-label {\n        margin-bottom: 5px;\n    }\n\n    .language-select {\n        width: 100%;\n        max-width: none;\n    }\n\n    .load-more-button {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
